import {
  AnchorProps as MantineAnchorProps,
  Anchor as MantineAnchor,
} from '@mantine/core';

export type AnchorProps = MantineAnchorProps;

export const Anchor = MantineAnchor as typeof MantineAnchor;

Anchor.displayName = 'Anchor';
